<template>
  <div>
    <div v-if="employeeShift">
      <InfoWorkShift :workShift="employeeShift" />
      <hr />
      <div class="ant-descriptions-title">Annual leave / Nghỉ phép năm</div>
      <small>
        Formula convert to hour unit <br />
        <i>
          Total Hour = Day *
          {{ employeeShift.duration }}
        </i>
      </small>
      <a-form-model ref="form" :model="form" style="overflow-y: auto;">
        <a-form-model-item label="Original / Số ngày nghỉ phép ban đầu">
          <a-input-number
            v-model="form.original"
            placeholder="Enter number"
            :parser="(value) => value.replace(/\$\s?|(,*)/g, '')"
            style="width: 100%;"
            @change="
              () => {
                form.defaultDays = calTotalALFromOriginal({
                  startedDate: employee.startedDate,
                  originalDays: form.original,
                });
                form.remainDays = form.defaultDays;
              }
            "
          />
        </a-form-model-item>
        <a-form-model-item
          label="Total day annual leave / Tổng số ngày nghỉ phép năm"
        >
          <a-input-number
            v-model="form.defaultDays"
            placeholder="Enter number"
            :parser="(value) => value.replace(/\$\s?|(,*)/g, '')"
            style="width: 100%;"
          />
        </a-form-model-item>
        <a-form-model-item
          label="Total day annual leave remain / Số ngày nghỉ phép còn lại"
        >
          <a-input-number
            v-model="form.remainDays"
            placeholder="Enter number"
            :parser="(value) => value.replace(/\$\s?|(,*)/g, '')"
            style="width: 100%;"
          />
        </a-form-model-item>
      </a-form-model>
    </div>
    <a-alert v-else message="Employee need update location or shift" banner />

    <div
      style="text-align: right;"
      :style="{
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e9e9e9',
        padding: '10px 16px',
        background: '#fff',
        textAlign: 'right',
        zIndex: 1,
      }"
    >
      <a-button @click="close" style="margin-right: 5px;">
        Close
      </a-button>
      <a-button
        type="primary"
        @click="onSubmit"
        icon="save"
        :loading="loadingBtn"
      >
        Update
      </a-button>
    </div>
  </div>
</template>
<script>
import query from "./constant/query";
import calTotalALFromOriginal from "../../services/calTotalALFromOriginal";
import InfoWorkShift from "@/components/common/workShift/Info";

export default {
  components: { InfoWorkShift },
  props: {
    close: {
      type: Function,
      default: () => {},
    },
    refreshEmployeeAfterLeaveAnualUpdated: {
      type: Function,
      default: () => {},
    },
    annualLeaveDay: {
      type: Object,
      default() {
        return {};
      },
    },
    employee: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      form: {},
      loadingBtn: false,
    };
  },
  computed: {
    employeeShift() {
      return (
        this.employee?.workShift || this.employee?.branchLocation?.mainShift
      );
    },
  },
  created() {
    if (this.employeeShift) {
      this.form = {
        defaultDays:
          +this.annualLeaveDay.default / +this.employeeShift.duration || null,
        remainDays:
          +this.annualLeaveDay.remain / +this.employeeShift.duration || null,
        original:
          +this.annualLeaveDay.original / +this.employeeShift.duration || null,
      };
    }
  },
  methods: {
    calTotalALFromOriginal,
    onSubmit() {
      if (this.annualLeaveDay?.id) {
        this.onUpdateEmployeeAnnualLeaveDay();
      } else {
        this.onCreateEmployeeAnnualLeaveDay();
      }
    },
    onCreateEmployeeAnnualLeaveDay() {
      const idEmployee = this.employee.id;
      this.loadingBtn = true;
      if (!idEmployee) {
        throw new Error("Không thể lấy id nhân viên");
      }
      this.$apollo
        .mutate({
          mutation: query.createEmployeeAnnualLeaveDay,
          variables: {
            employeeId: idEmployee,
            original: +this.form.original * +this.employeeShift.duration || 0,
            default: +this.form.defaultDays * +this.employeeShift.duration || 0,
            remain: +this.form.remainDays * +this.employeeShift.duration || 0,
          },
        })
        .then(({ data }) => {
          if (data?.createEmployeeAnnualLeaveDay?.id) {
            this.refreshEmployeeAfterLeaveAnualUpdated(
              data.createEmployeeAnnualLeaveDay
            );
          }
          this.loadingBtn = false;
          this.$notification.success({
            message: "Success",
            description: "Updated Success!",
          });
          this.close();
        })
        .catch((err) => {
          this.loadingBtn = false;
          this.$notification.error({
            message: "Error",
            description: "Updated Error!",
          });
          console.log(
            "Thêm mới ngày nghỉ phép hằng năm của nhân viên không thành công",
            err
          );
        });
    },
    onUpdateEmployeeAnnualLeaveDay() {
      this.loadingBtn = true;
      this.$apollo
        .mutate({
          mutation: query.updateEmployeeAnnualLeaveDay,
          variables: {
            id: this.annualLeaveDay.id,
            original: +this.form.original * +this.employeeShift.duration || 0,
            default: +this.form.defaultDays * +this.employeeShift.duration || 0,
            remain: +this.form.remainDays * +this.employeeShift.duration || 0,
          },
        })
        .then(({ data }) => {
          if (data?.updateEmployeeAnnualLeaveDay?.id) {
            this.refreshEmployeeAfterLeaveAnualUpdated(
              data.updateEmployeeAnnualLeaveDay
            );
          }
          this.loadingBtn = false;
          this.$notification.success({
            message: "Success",
            description: "Updated Success!",
          });
          this.close();
        })
        .catch((err) => {
          this.loadingBtn = false;
          this.$notification.error({
            message: "Error",
            description: "Updated Error!",
          });
          console.log(
            "Cập nhật ngày nghỉ phép hằng năm của nhân viên không thành công",
            err
          );
        });
    },
  },
};
</script>
<style lang="css" scoped></style>
